<div *ngIf="wishlist?.length" class="p-4 bg-white rounded-3 mobile-pd">
  <!-- <div class="title-header">
    <div class="d-flex align-wishlist-center w-100">
      <div class="input-group align-wishlist-center border div-search">
        <input id="quiclSearchInput" type="search" class="form-control border-0 bg-transparent search-input"
          placeholder="Bạn đang tìm sản phẩm gì?" [(ngModel)]="inputText" (keyup)="input()" />
        <i class="ri-search-line d-flex justify-content-center align-items-center search-icon"></i>
      </div>
    </div>
  </div> -->
  <div>
    <div class="d-flex flex-column gap-3">
      <app-product-box-vertical
        *ngFor="let item of wishlist"
        class="w-100"
        [product]="item"
      ></app-product-box-vertical>
    </div>
    <app-collection-paginate> </app-collection-paginate>
  </div>
</div>
<app-no-data [class]="'no-data-added'" [image]="'assets/svg/empty-items.svg'" [text]="'Bạn chưa có sản phẩm yêu thích!'"
  [description]="'Hãy thêm sản phẩm bạn yêu thích nhé!'" *ngIf="!wishlist.length">
</app-no-data>
